/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-mailing-lists" */ `./list.vue` );
const Add = () => import( /* webpackChunkName: "group-mailing-lists" */ `./add.vue` );
const Edit = () => import( /* webpackChunkName: "group-mailing-lists" */ `./edit.vue` );

export default {
	path: `mailing-lists`,
	children: [
		{
			path: ``,
			name: `list-mailing_lists`,
			component: List,
			meta: {
				title: `Mailing Lists`
			}
		},
		{
			path: `new`,
			name: `add-mailing_list`,
			component: Add,
			meta: {
				title: `Add Mailing List`
			}
		},
		{
			path: `:uuid`,
			name: `edit-mailing_list`,
			component: Edit,
			meta: {
				title: `Edit Mailing List`
			}
		}
	]
};
